/*jshint esversion: 6 */

(function () {
	'use strict';
	$(function () {

		var lsRegisteredKey = 'e-registered';
		var lsRegisteredValue = 's676C-gq6<XxRV';
		var lsFormCompleted = 'sJSD73DM-dEQbSKVu';

		var lsFilterClicks = 'e-clicks';
		window.filterClicksCount = localStorage.getItem(lsFilterClicks) ? parseInt(localStorage.getItem(lsFilterClicks)) : 0;

		window.updateFilterClicks = function () {
			window.filterClicksCount++;
			localStorage.setItem(lsFilterClicks, window.filterClicksCount);
		}

		window.checkFilterChange = function () {
			if (window.filterClicksCount < ((window.location.href.indexOf("flyhigh") > -1) ? 10000 : 10))
				return true;
			else if (localStorage.getItem(lsRegisteredKey) === lsRegisteredValue)
				return true;
			else
				return false;
			return true;
		};

		$(document).ready(function () {

			$('[data-fancybox]').fancybox({
				toolbar: false,
				smallBtn: true,
				btnTpl: {
					smallBtn: '<div data-fancybox-close class="fancybox-close-small modal-close"></div>'
				}
			});

			$('a[href^="#"]').click(function (e) {
				var target = this.hash;
				if (target) {
					var $target = $(target);
					$('html, body').stop().animate({
						'scrollTop': $target.offset().top
					}, 900, 'swing', function () {
						//window.location.hash = target;
					});
				}
			});

			$('body').on('click', 'input, select', function () {
				if (!window.checkFilterChange()) {
					$('#unlock-button').click();
					return false;
				}
			})

			function bindEvent(element, eventName, eventHandler) {
				if (element.addEventListener) {
					element.addEventListener(eventName, eventHandler, false);
				} else if (element.attachEvent) {
					element.attachEvent('on' + eventName, eventHandler);
				}
			}

			bindEvent(window, 'message', function (e) {
				if (e.data === lsRegisteredValue) {
					localStorage.setItem(lsRegisteredKey, lsRegisteredValue);
					fbq('track', 'Search');
				} else if (e.data === lsFormCompleted) {
					fbq('track', 'CompleteRegistration');
				}
			});

		});

	});
}(jQuery));
